import api from "../api";

export async function GetJobList(type) {
  console.log(type, "typejob");
  let language_id = localStorage.getItem("lang_id");
  const userId = localStorage.getItem("user_id");
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/job/fetch-job?type=${type}&language_id=${language_id}&userId=${userId}`,
  });
}

export async function checkCompanyLinkedInStatus() {
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/job/fetch-company/`,
  });
}

export async function updatestatus(vacancy_id, status, comment) {
  let authUser = JSON.parse(localStorage.getItem("authUser"));
  let user_id = authUser.user.id;
  let role_id = authUser.user.role_id;
  return await api({
    method: "put",
    url: `${process.env.REACT_APP_API_URL}/admin/job/update-status/${vacancy_id}`,
    data: { status, user_id, role_id, comment },
  });
}

export async function updateArchiveStatus(vacancy_id, status) {
  return await api({
    method: "put",
    url: `${process.env.REACT_APP_API_URL}/admin/job/update-archive_status/${vacancy_id}`,
    data: { status },
  });
}
